import { useSelector } from 'react-redux'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import SwapIcon from 'assets/svgr-icons/SwapHorizontal.svg'
import Frame from './Frame'
import { useFrameHandlers } from '../hooks/useFrameHandlers'
import * as Styled from './styled'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { ReferenceMediaImageType } from 'types/aiVideo'

const FramesSelector = () => {
  const firstFrame = useSelector(aiVideoSelectors.firstFrame)
  const lastFrame = useSelector(aiVideoSelectors.lastFrame)
  const { addFrameFromMediaLib, onUploadFrame, handleRemoveFrame, handleSwap } =
    useFrameHandlers()

  const canSetLastFrame = Boolean(firstFrame?.url)
  const canSwap = Boolean(firstFrame?.url || lastFrame?.url)

  return (
    <Styled.Container>
      <Frame
        type={ReferenceMediaImageType.FIRST_FRAME}
        label={translate(T.START_FRAME_LABEL)}
        frameData={firstFrame}
        onMediaLibFileSelect={addFrameFromMediaLib}
        onUpload={onUploadFrame}
        onRemove={handleRemoveFrame}
        testId="start-frame"
      />
      <Styled.SwapButton
        $disabled={!canSwap}
        onClick={handleSwap}
        type="button"
      >
        <SwapIcon />
      </Styled.SwapButton>
      <Frame
        type={ReferenceMediaImageType.LAST_FRAME}
        label={translate(T.END_FRAME_LABEL)}
        sublabel={translate(T.OPTIONAL_LABEL)}
        frameData={lastFrame}
        onMediaLibFileSelect={addFrameFromMediaLib}
        onUpload={onUploadFrame}
        onRemove={handleRemoveFrame}
        disabled={!canSetLastFrame}
        testId="end-frame"
      />
    </Styled.Container>
  )
}

export default FramesSelector
